import { CollectionProduct } from 'models/collection/collection';

/**
 * Checks if product is bundle product by tag
 */
export const isBundleProduct = (product: CollectionProduct): boolean => {
  const tags = product.tags || [];
  return tags.includes('Probierpaket') || tags.includes('Purpose Box') || tags.includes('Bundle');
};
